import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // slab.cash odds + pulls don't change minute-to-minute, so hold results
      // for 10 min before they're considered stale and keep them in memory for
      // an hour. Combined with the edge CDN cache on /api/* and the
      // background prefetcher (App.tsx), tab switches are instant after the
      // first warm-up — no refetch spinner until the data genuinely ages out.
      staleTime: 10 * 60_000,
      gcTime: 60 * 60_000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      // If an API call fails, don't block the tab with repeated retries —
      // a single retry is enough for transient blips.
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
